import React, { Suspense, lazy } from 'react';
import delve from 'dlv';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { GatsbyImage } from 'gatsby-plugin-image';

import RichText from 'components/common/RichText';
import media from 'utils/media';

const Markdown = lazy(() => import('components/elements/Markdown'));

const ImageContent = ({ title, heading, image, contentRt, contentTextPosition, textAlignement }) => {
  const imageUrl = delve(image, 'url') && (image.url[0] === '//' ? `https:${image.url}` : image.url);

  return (
    <Section contentPosition={contentTextPosition}>
      <TextWrapper data-test="text-wrapper" contentPosition={contentTextPosition} textAlignement={textAlignement}>
        {title && title.length > 0 && <h1>{title}</h1>}
        {!title && delve(heading, 'markdown.html') && (
          <Suspense fallback={<div />}>
            <Markdown>{heading.markdown.html}</Markdown>
          </Suspense>
        )}
        {contentRt && <RichText document={contentRt} />}
      </TextWrapper>
      {delve(image, 'url') && <img src={imageUrl} alt={image.title || title || ''} loading="lazy" />}
      {!delve(image, 'url') && delve(image, 'gatsbyImageData') && (
        <GatsbyImage image={image.gatsbyImageData} alt={image.title || title || ''} />
      )}
    </Section>
  );
};

export default ImageContent;

const Section = styled.section`
  display: flex;
  flex-direction: ${({ contentPosition }) =>
    contentPosition === 'top' || contentPosition === 'bottom' ? 'column' : 'row'};
`;

const TextWrapper = styled.div`
  order: ${({ contentPosition }) => (contentPosition === 'right' || contentPosition === 'bottom' ? 1 : 0)};

  ${({ textAlignement }) =>
    textAlignement &&
    css`
      ${media.greaterThan.md} {
        text-align: ${textAlignement};
      }
    `}
`;
